import { createSlice,PayloadAction } from '@reduxjs/toolkit';
import { signOut } from 'aws-amplify/auth';
import ToasterWithMessage from '../../components/toaster';
import { PTA_ROLE } from '../../utils/constants';
import { getScreenDimensions } from '../../utils/helper';
import posthog from 'posthog-js';

interface AuthState {
  role: string | null;
  isSplashVisible: boolean;
  adminProfile: any;
  loginpage: string | null;
  teacherMainRoute: string | null;
  selectedClassRoomId: string | null;
  selectedClassRoomName: string | null;
  adminProfileImage: string | null;
  refetchCurrentUser: boolean;
  adminId: string;
  isNotificationEnabled : boolean;
  refetchNotification: boolean;
  systemMessagesCount : number;
  isSidebarOpen: boolean;
  isKaton: string | null;
  participantCode: string | null;
  meetService: string | undefined;
  meetServiceOrganization: string | undefined;
  jitsiRecordingService: string | undefined;
  schoolType: string | null;
  facilitatorsBySaId: string | undefined;
  selectedTabindex: string;
  loginAs: "student" | "teacher" | "pta" | "schooladmin";
  hideScrollToTopButton: boolean;
  defaultVideoMute: boolean;
  defaultAudioMute: boolean;
}

const {error} = ToasterWithMessage();

const loginUser: any = localStorage.getItem("loginAs") || "student";

//initialState storing the accessToken and role from the localStorage
const initialState: AuthState = {
  role: localStorage.getItem('role'),
  isSplashVisible: true,
  adminProfile: {},
  loginpage: localStorage.getItem('loginpage'),
  teacherMainRoute: localStorage.getItem('teacherMainRoute'),
  selectedClassRoomId: localStorage.getItem('selectedClassId'),
  selectedClassRoomName: localStorage.getItem('selectedClassName'),
  adminProfileImage: '',
  refetchCurrentUser: false,
  adminId : '',
  isNotificationEnabled : false,
  refetchNotification: false,
  systemMessagesCount : 0,
  isSidebarOpen: false,
  isKaton: localStorage.getItem('isKaton') || null,
  participantCode: localStorage.getItem('participantCode') || null,
  meetService: process.env.REACT_APP_MEET_SERVICE,
  schoolType: localStorage.getItem('schoolType'),
  facilitatorsBySaId: "",
  selectedTabindex: localStorage?.getItem('teacherStudentTabIndex') || '0',
  meetServiceOrganization: process.env.REACT_APP_ORGANIZATION_MEET_SERVICE,
  jitsiRecordingService: process.env.REACT_APP_JITSI_RECORD_SERVICE,
  loginAs: loginUser,
  hideScrollToTopButton: getScreenDimensions()?.isMobileScreen,
  defaultVideoMute: process.env.REACT_APP_DEFAULT_VIDEO_MUTE === "true",
  defaultAudioMute: process.env.REACT_APP_DEFAULT_AUDIO_MUTE === "true"
};
export const cognitoLogout = async () => {
  await signOut().catch(() => error("Something went wrong while logout"))
}
const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login(state,action: PayloadAction<{role: string}>) {
      const accessToken =localStorage.getItem(Object.keys(localStorage).find((key) => key.includes('accessToken')) as string) || null;
      if(accessToken){
        state.role = action.payload.role;
        localStorage.setItem('role', action.payload.role);
        localStorage.removeItem('vs_temp_tokens');
      }
      else{
        const registeredUsername = localStorage.getItem('registered_username');
        const vsTempTokens = localStorage.getItem('vs_temp_tokens');
        localStorage.clear();
        if (registeredUsername) {
          localStorage.setItem('registered_username', registeredUsername);
        }
        if (vsTempTokens) {
          localStorage.setItem('vs_temp_tokens', vsTempTokens);
        }
        state.role = null;
      }
    },
    logout(state) {
      posthog.reset();
      cognitoLogout();
      const generalCode = state.role === PTA_ROLE ? localStorage.getItem('generalCode') : "";
      const SaId = localStorage.getItem('saId');
      const isKaton = localStorage.getItem('isKaton');
      const loginAs = localStorage.getItem('loginAs');
      const registeredUsername = localStorage.getItem('registered_username');
      const vsTempTokens = localStorage.getItem('vs_temp_tokens');
      localStorage.clear();
      if (generalCode) {
        localStorage.setItem('generalCode', generalCode);
      }
      if (SaId) {
        localStorage.setItem('saId', SaId);
      }
      if (isKaton) {
        localStorage.setItem('isKaton', isKaton);
      }
      if (loginAs) {
        localStorage.setItem('loginAs', loginAs);
      }
      if (registeredUsername) {
        localStorage.setItem('registered_username', registeredUsername);
      }
      if (vsTempTokens) {
        localStorage.setItem('vs_temp_tokens', vsTempTokens);
      }
      state.role = null;
      state.loginpage = null;
      state.schoolType = null;
      state.selectedClassRoomId = null;
      state.selectedClassRoomName = null;
      state.teacherMainRoute = null;
      state.isSidebarOpen = false;
    },
    setSplashvisible(state) {
      state.isSplashVisible = false;
    },
    setAdminProfile(state, action: PayloadAction<{profile: any}>) {
      localStorage.setItem('adminProfile', JSON.stringify(action.payload.profile));
      state.adminProfile = action.payload.profile;
    },
    setLoginPage(state, action: PayloadAction<{loginPage: any}>){
      localStorage.setItem('loginpage',action.payload.loginPage);
      state.loginpage = action.payload.loginPage;
    },
    setTeacherMainRoute(state, action: PayloadAction<{teacherMainRoute: any}>){
      localStorage.setItem('teacherMainRoute',action.payload.teacherMainRoute);
      state.teacherMainRoute = action.payload.teacherMainRoute;
    },
    setSelectedClassRoomId(state, action: PayloadAction<{selectedClassRoomId: any}>){
      localStorage.setItem('selectedClassId',action.payload.selectedClassRoomId);
      state.selectedClassRoomId = action.payload.selectedClassRoomId;
    },
    setSelectedClassRoomName(state, action: PayloadAction<{selectedClassRoomName: any}>){
      localStorage.setItem('selectedClassName',action.payload.selectedClassRoomName);
      state.selectedClassRoomName = action.payload.selectedClassRoomName;
    },
    setAdminProfileImage(state, action: PayloadAction<{adminProfileImage: string | null }>){
      state.adminProfileImage = action.payload.adminProfileImage;
    },
    setRefetchCurrentUser(state, action: PayloadAction<{refetchCurrentUser: boolean}>){
      state.refetchCurrentUser = action.payload.refetchCurrentUser;
    },
    setAdminId (state,  action: PayloadAction<string>){
      state.adminId = action.payload
    },
    setIsNotificationEnable (state,action : PayloadAction<boolean>){
      state.isNotificationEnabled = action.payload
    },
    setRefetchNotification(state, action: PayloadAction<{refetchNotification: boolean}>){
      state.refetchNotification = action.payload.refetchNotification;
    },
    setSystemMessagesCount(state, action: PayloadAction<number>){
      state.systemMessagesCount = action.payload;
    },
    setIsSidebarOpen(state, action: PayloadAction<{isSidebarOpen: boolean}>){
      state.isSidebarOpen = action.payload.isSidebarOpen;
    },
    setLoginUser(state, action: PayloadAction<{loginAs: "student" | "teacher" | "pta" | "schooladmin"}>) {
      localStorage.setItem("loginAs", action.payload.loginAs)
      state.loginAs = action.payload.loginAs;
    },
    setSchoolType(state, action: PayloadAction<{schoolType: any}>){
      // Skip missing values, they would persist the string "undefined". logout() clears this.
      if (action.payload.schoolType === undefined || action.payload.schoolType === null) {
        return;
      }
      localStorage.setItem('schoolType',action.payload.schoolType);
      state.schoolType = action.payload.schoolType;
    },
    setSelectedTabindex(state, action: PayloadAction<{selectedTabindex: string}>){
      state.selectedTabindex = action.payload.selectedTabindex;
    },
    setHideScrollToTopButton(state, action: PayloadAction<{hideScrollToTopButton: boolean}>){
      state.hideScrollToTopButton = action.payload.hideScrollToTopButton;
    },
  },
});

export const { login, logout, setSplashvisible, setAdminProfile , setLoginPage, setTeacherMainRoute, setSelectedClassRoomId, setSelectedClassRoomName, setAdminProfileImage, setRefetchCurrentUser, setAdminId, setIsNotificationEnable, setRefetchNotification, setSystemMessagesCount, setIsSidebarOpen, setSchoolType, setSelectedTabindex, setLoginUser, setHideScrollToTopButton } = authSlice.actions;
export default authSlice.reducer;